import {View} from 'react-native'
import {Trans, useLingui} from '@lingui/react/macro'

import {atoms as a, useTheme} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import * as Dialog from '#/components/Dialog'
import {useNuxDialogContext} from '#/components/dialogs/nuxs'
import {createIsEnabledCheck} from '#/components/dialogs/nuxs/utils'
import {Beaker_Stroke2_Corner2_Rounded as BeakerIcon} from '#/components/icons/Beaker'
import {Text} from '#/components/Typography'
import {IS_E2E, IS_IPAD} from '#/env'

export const enabled = createIsEnabledCheck(() => IS_IPAD && !IS_E2E)

export function IPadBetaAnnouncement() {
  const t = useTheme()
  const {t: l} = useLingui()
  const nuxDialogs = useNuxDialogContext()
  const control = Dialog.useDialogControl()

  Dialog.useAutoOpen(control)

  return (
    <Dialog.Outer
      control={control}
      onClose={() => nuxDialogs.dismissActiveNux()}
      nativeOptions={{preventExpansion: true}}>
      <Dialog.Handle />
      <Dialog.ScrollableInner label={l`iPad support is here`}>
        <View style={[a.align_center, a.gap_2xl]}>
          <View style={[a.align_center, a.gap_sm]}>
            <View style={[a.flex_row, a.align_center, a.gap_xs]}>
              <BeakerIcon fill={t.palette.primary_700} size="sm" />
              <Text style={[a.font_semi_bold, {color: t.palette.primary_700}]}>
                <Trans>Beta Feature</Trans>
              </Text>
            </View>
            <Text
              style={[
                a.leading_tight,
                a.font_bold,
                a.text_center,
                {fontSize: 32, maxWidth: 360},
              ]}>
              <Trans>iPad support is here</Trans>
            </Text>
            <Text
              style={[
                a.text_md,
                a.leading_snug,
                a.text_center,
                {maxWidth: 340},
              ]}>
              <Trans>
                Bluesky now makes full use of your iPad’s screen, in any
                orientation. It’s still in beta, so if something looks off, let
                us know in Settings → Beta features.
              </Trans>
            </Text>
          </View>

          <Button
            label={l`Got it`}
            size="large"
            color="primary"
            onPress={() => control.close()}
            style={[a.w_full]}>
            <ButtonText>
              <Trans>Got it</Trans>
            </ButtonText>
          </Button>
        </View>
      </Dialog.ScrollableInner>
    </Dialog.Outer>
  )
}
